export default __webpack_public_path__ + "static/media/home-logo.958bbbd5.svg";